import React from 'react';
import { OrderFlow } from '../types/order/orderFlow';

export interface OrderFlowContextProps {
  orderFlows: Map<string, OrderFlow>;
  setOrderFlows: (orderFlows: Map<string, OrderFlow>) => void;
  orderFlowsLoading: boolean;
}

const defaultContext: OrderFlowContextProps = {
  orderFlows: new Map(),
  setOrderFlows: () => {},
  orderFlowsLoading: false,
};

export const OrderFlowContext = React.createContext<OrderFlowContextProps>(defaultContext);
